import client from './main-client';

export const fetchLenderLoansApi = (params) => client().get('/lender-company-loans', { params });

export const sendLenderInfoLoansApi = (data) => client().post('/lender-company-loans?lenderLoanCount=true&lenderLoanAmount=true', data);
